export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6640.7da1c382.jpg";